/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/currency';
import '../../../legalentities/model/model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "fr": {
                "nested": {
                  "model": {
                    "nested": {
                      "Business": {
                        "fields": {
                          "type": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "businessName": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "businessAddressToken": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "tradingName": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "tradingAddressToken": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "vatNumber": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          },
                          "vatName": {
                            "type": "string",
                            "id": 14,
                            "rule": "optional"
                          },
                          "vatAddress": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          },
                          "vatCountryCode": {
                            "type": "string",
                            "id": 16,
                            "rule": "optional"
                          },
                          "websiteUrl": {
                            "type": "string",
                            "id": 17,
                            "rule": "optional"
                          },
                          "siretNumber": {
                            "type": "string",
                            "id": 18,
                            "rule": "optional"
                          },
                          "countryOfRegistration": {
                            "type": "string",
                            "id": 19,
                            "rule": "optional"
                          },
                          "rcsNumber": {
                            "type": "string",
                            "id": 20,
                            "rule": "optional"
                          },
                          "nafCode": {
                            "type": "string",
                            "id": 21,
                            "rule": "optional"
                          },
                          "sharesCapital": {
                            "type": ".squareup.common.Money",
                            "id": 23,
                            "rule": "optional"
                          },
                          "verificationId": {
                            "type": "string",
                            "id": 24,
                            "rule": "optional"
                          },
                          "documentFiles": {
                            "type": ".squareup.legalentities.model.Business.DocumentFile",
                            "id": 25,
                            "rule": "repeated"
                          }
                        }
                      },
                      "Persona": {
                        "fields": {}
                      },
                      "Bank": {
                        "fields": {
                          "iban": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "swiftBic": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.fr?.nested?.model?.nested?.Business && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.fr?.nested?.model?.nested?.Persona && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.fr?.nested?.model?.nested?.Bank) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Business @ squareup/onboard/activation/fr/model.proto at 12:1
 */
export const Business = $root.lookupType('squareup.onboard.activation.fr.model.Business');
fixType(Business);
Builder.createAndAttachToType(Business);
/**
 * SOURCE Persona @ squareup/onboard/activation/fr/model.proto at 94:1
 */
export const Persona = $root.lookupType('squareup.onboard.activation.fr.model.Persona');
fixType(Persona);
Builder.createAndAttachToType(Persona);
/**
 * SOURCE Bank @ squareup/onboard/activation/fr/model.proto at 98:1
 */
export const Bank = $root.lookupType('squareup.onboard.activation.fr.model.Bank');
fixType(Bank);
Builder.createAndAttachToType(Bank);